import React, { FC } from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { AnimatedLink } from '../../../doctrine/components/animated-link/AnimatedLink';
import { LightHeader } from '../../../doctrine/header/light/LightHeader';
import { NavCustomerButton } from '../../../doctrine/navigation/customers/NavCustomerButton';
import { NavFeaturesButton } from '../../../doctrine/navigation/features/NavFeaturesButton';
import { NavLoginButton } from '../../../doctrine/navigation/login/NavLoginButton';
import { NavPublicPricing } from '../../../doctrine/navigation/pricing/NavPublicPricing';
import { NavSignupButton } from '../../../doctrine/navigation/signup/NavSignupButton';
import { useLoggedIn } from './useLoggedIn';
import { NavItem } from '../../../doctrine/navigation/components/item/NavItem';
import { NavHeader } from '../../../doctrine/navigation/components/header/NavHeader';
import { NavGroup } from '../../../doctrine/navigation/components/group/NavGroup';
import { Nav } from '../../../doctrine/navigation/components/Nav';

const BaseHeader: FC = ({ children }) => (
  <LightHeader source="nav">
    <NavHeader>
      <NavGroup>
        <Nav dataTestId="nav-public">
          <NavFeaturesButton />
          <NavCustomerButton />
          <NavPublicPricing />
          {children}
        </Nav>
      </NavGroup>
    </NavHeader>
  </LightHeader>
);

const LoggedInHeader: FC = () => (
  <BaseHeader>
    <NavToDoctrine />
  </BaseHeader>
);

export const LoggedOutHeader: FC<{ pageName: string }> = ({ pageName }) => (
  <BaseHeader>
    <NavLoginButton />
    <NavSignupButton manualSourcePage={pageName} />
  </BaseHeader>
);

export const PublicHeader: FC<{ pageName: string }> = ({ pageName }) => {
  const isLoggedIn = useLoggedIn();
  return isLoggedIn ? (
    <LoggedInHeader />
  ) : (
    <LoggedOutHeader pageName={pageName} />
  );
};

const NavToDoctrine: FC = () => {
  const data = useStaticQuery(graphql`
    {
      prismic {
        allHeaders {
          edges {
            node {
              go_to_doctrine
            }
          }
        }
      }
    }
  `);

  return (
    <NavItem>
      <AnimatedLink href="/" source="marketing_header">
        {data.prismic.allHeaders.edges[0].node.go_to_doctrine}
      </AnimatedLink>
    </NavItem>
  );
};
